<template>
    <a class="link" v-bind="$attrs" :class="{'link--disabled':disable, 'link--no-decor':!decor}"
       v-on="$listeners"
    >
        <slot></slot>
    </a>
</template>

<script>
export default {
  name : 'Link',
  props: {
    decor: {
      type   : Boolean,
      default: true,
    },
    disable: {
      type   : Boolean,
      default: false,
    },
  },

};
</script>
